module.exports = __webpack_public_path__ + "img/vapp-by-finanzchecks-long-logo-singleline.68bd5be6.svg";